import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UpdateDataTokenCode } from 'src/app/shared/class/update-data';
import {
  DataSelects,
  ExperienceType,
  Occupation,
  State,
  VehicleOwners,
} from 'src/app/shared/interfaces/data-selects';
import { StepOCRLtoResponse } from 'src/app/shared/interfaces/step-data';
import { RequestInformationComponent } from 'src/app/shared/request-information/request-information.component';
import { GetDataService } from 'src/app/shared/services/get-data.service';
import { PutDataService } from 'src/app/shared/services/put-data.service';
import { RequestFormService } from 'src/app/shared/services/request-form.service';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';
import { FormsValidators } from 'src/app/shared/utils/forms-validators';

@Component({
  selector: 'app-step-validacion-datos-lto',
  templateUrl: './step-validacion-datos-lto.component.html',
  styleUrls: ['./step-validacion-datos-lto.component.scss'],
})
export class StepValidacionDatosLtoComponent extends AutoUnsubscribeComponent implements OnInit {
  @Input() saveRequest!: Observable<boolean>;
  @Input() dataValidationDataLto!: DataSelects;
  @Output() formValidEvent = new EventEmitter<boolean>();
  @Output() stepValidationDataLtoSavedEvent = new EventEmitter<boolean>();

  public selectedDate = new Date();
  public formStepDataValidationLto!: FormGroup;
  public drivingRole: ExperienceType[] = [];
  public creditTypeUpdate!: string;
  public vehicleRelation: VehicleOwners[] = [];
  public vehicleCategories: Occupation[] = [];
  public codePostal!: any;
  public colonies: State[] = [];

  constructor(
    private frmBuilder: FormBuilder,
    private putDataService: PutDataService,
    private dialog: MatDialog,
    private requestFormService: RequestFormService,
    private router: Router,
    private getDataService: GetDataService
  ) {
    super();

    const POSTALCODE = /^[0-9]{5}$/;
    const NUMEXT = /^([a-zA-Z0-9]+\s*)*[a-zA-Z0-9]+$/;
    this.formStepDataValidationLto = this.frmBuilder.group({
      dateOfBirth: [{ value: '', disabled: true }],
      currentScore: [{ value: '', disabled: true }],
      uberProCategory: [{ value: '', disabled: true }],
      drivingRole: [
        '',
        [Validators.required],
      ],
      timeInApplication: [{ value: '', disabled: true }],
      totalTrips: [{ value: '', disabled: true }],
      acceptanceIndex: [{ value: '', disabled: true }],
      cancellationIndex: [{ value: '', disabled: true }],
      averageAmountUber: [
        '',
        [Validators.required, Validators.maxLength(8)],
      ],
      postalCodeId: [
        '',

        [Validators.required, Validators.pattern(POSTALCODE)],
      ],
      street: [
        '',

        [Validators.required, Validators.maxLength(50)],
      ],
      externalNumber: [
        '',

        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern(NUMEXT),
        ],
      ],
      internalNumber: [
        '',

        [Validators.maxLength(10), Validators.pattern(NUMEXT)],
      ],
      colonyId: [
        '',

        [Validators.required],
      ],
      stateId: [
        '',

        [Validators.required],
      ],
      municipalityId: [
        '',

        [Validators.required, Validators.maxLength(45)],
      ],
      vehicleRelationCode: [
        '',

        [Validators.required],
      ],
      rentAmount: [
        '',

        [Validators.maxLength(10)],
      ],
      vehicleCategoryId: [
        '',

        [Validators.required],
      ],
      totalDependents: [
        '',

        [Validators.required, Validators.maxLength(2)],
      ],
    });
  }

  ngOnInit(): void {
    this.checkEvent();

    if (this.requestFormService.getUpdateForm()) {
      this.loadUpdateFormStep2();
    }

    this.requestFormService
      .getDataDocumentsOCRObservableLTO()
      .subscribe((resp) => {
        this.loadDataOCR(resp);
      });

    if (!this.requestFormService.getDataForm().requestNumber) {
      this.loadDataOCR(this.requestFormService.getDataDocumentsOCRLTO());
    }

    this.saveRequest.subscribe((value) => {
      if (value) {
        if (this.formStepDataValidationLto.dirty) {
          this.saveStep2();
        } else {
          this.stepValidationDataLtoSavedEvent.emit(true);
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataValidationDataLto']?.currentValue) {
      this.drivingRole = this.dataValidationDataLto.drivingRoles;
      this.vehicleRelation = this.dataValidationDataLto.vehicleRelations;
      this.vehicleCategories = this.dataValidationDataLto.vehicleCategories;
    }
  }

  checkEvent() {
    this.formValidEvent.emit(!this.formStepDataValidationLto.invalid);
  }

  loadDataOCR(value: StepOCRLtoResponse) {
    const dataUber = value?.uberResponse;

    const fleetPartner = this.drivingRole.find(
      (op) => op.code == 'FLEET_PARTNER'
    );

    if (fleetPartner && value.uberResponse.isPartner === true) {
      this.formStepDataValidationLto
        .get('drivingRole')
        ?.setValue(fleetPartner.code);
    }

    const driver = this.drivingRole.find((op) => op.code == 'DRIVER');

    if (driver && value.uberResponse.isPartner === false) {
      this.formStepDataValidationLto.get('drivingRole')?.setValue(driver.code);
    }

    if (
      dataUber?.dateOfBirth != null ||
      dataUber?.uberProCategory != null ||
      dataUber?.rating != null ||
      dataUber?.acceptanceRate != null ||
      dataUber?.cancellationRate != null ||
      dataUber?.totalTrips != null ||
      dataUber?.antiquity != null ||
      dataUber?.average
    ) {
      this.formStepDataValidationLto.patchValue({
        dateOfBirth: value.uberResponse?.dateOfBirth
          ? new Date(
            value.uberResponse?.dateOfBirth.replace(
              /(\d+[/])(\d+[/])/,
              '$2$1'
            )
          )
          : '',
        uberProCategory: value.uberResponse?.uberProCategory,
        currentScore: value.uberResponse?.rating,
        acceptanceIndex: value.uberResponse?.acceptanceRate,
        cancellationIndex: value.uberResponse?.cancellationRate,
        totalTrips: value.uberResponse?.totalTrips,
        timeInApplication: value.uberResponse.antiquity,
        averageAmountUber: value.uberResponse?.average,
      });
    } else {
      this.formStepDataValidationLto.patchValue({
        currentScore: value?.scannedDataResponse.rating,
        uberProCategory: value?.scannedDataResponse.uberProCategory,
        timeInApplication: value?.scannedDataResponse.antiquity,
        totalTrips: value?.scannedDataResponse.totalTrips,
        acceptanceIndex: value?.scannedDataResponse.acceptanceRate,
        cancellationIndex: value?.scannedDataResponse.cancellationRate,
        averageAmountUber: value?.scannedDataResponse.average,
      });
    }
    this.checkEvent();
  }

  getStep2Object(): any {
    return {
      ...this.formStepDataValidationLto.value,
      drivingRole: this.formStepDataValidationLto.get('drivingRole')?.value,
      averageAmountUber:
        this.formStepDataValidationLto.get('averageAmountUber')?.value,
      stateId: this.codePostal.state.id,
      postalCodeId: this.codePostal.id,
      municipalityId: this.codePostal.municipality.id,
      totalDependents: parseInt(
        this.formStepDataValidationLto.get('totalDependents')?.value,
        10
      ),
      street: this.formStepDataValidationLto.get('street')?.value,
      externalNumber:
        this.formStepDataValidationLto.get('externalNumber')?.value,
      internalNumber:
        this.formStepDataValidationLto.get('internalNumber')?.value,
      vehicleRelationCode: this.formStepDataValidationLto.get(
        'vehicleRelationCode'
      )?.value,
      rentAmount: this.formStepDataValidationLto.get('rentAmount')?.value,
      vehicleCategoryId:
        this.formStepDataValidationLto.get('vehicleCategoryId')?.value,
      colonyId: this.formStepDataValidationLto.get('colonyId')?.value,
    };
  }

  openRequestInProgressDialog() {
    const promoter =
      this.requestFormService.getDataPromoterLTO() != undefined
        ? this.requestFormService.getDataPromoterLTO()
        : this.requestFormService.getUpdateForm()?.welcome?.promoter;

    let errorMessage = 'Ha ocurrido un error.';

    if (promoter?.telephone != null && promoter?.email != null) {
      errorMessage = `Tu ejecutivo de ventas es <strong>${promoter?.name}</strong> y lo puedes encontrar en el siguiente teléfono
      <strong>${promoter?.telephone}</strong> o correo <strong>${promoter?.email}</strong>, quien te puede dar mayor información.`;
    }
    if (promoter?.telephone != null) {
      errorMessage = `Tu ejecutivo de ventas es <strong>${promoter?.name}</strong> y lo puedes encontrar en el siguiente teléfono <strong>${promoter?.telephone}</strong>
         , quien te puede dar mayor información.`;
    }
    if (promoter?.email != null) {
      errorMessage = `Tu ejecutivo de ventas es <strong>${promoter?.name}</strong> y lo puedes encontrar en el siguiente correo <strong>${promoter?.email}</strong>
         , quien te puede dar mayor información.`;
    }
    if (
      (promoter?.telephone === null && promoter?.email === null) ||
      this.requestFormService.getUpdateForm()?.welcome?.promoter.name
    ) {
      errorMessage = `Tu ejecutivo de ventas es <strong>${promoter?.name}</strong>, quien te puede dar mayor información.`;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = {
      title: 'Solicitud en progreso',
      question: `Tu solicitud ha sido pre-autorizada y como segundo paso será revisada por nuestro equipo de análisis,
    recibiras una respuesta en 48-72 horas por correo.
         \n ${errorMessage}`,
    };
    const dialogSubscription$ = this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => {
        this.router.navigate(['/busqueda']);
        sessionStorage.clear();
      });
    this.subscriptions.push(dialogSubscription$);
  }

  saveStep2() {
    if (
      this.formStepDataValidationLto.valid ||
      this.requestFormService.getUpdateForm()
    ) {
      const putUpdateRequestDataValidation$ = this.putDataService
        .putUpdateRequestDataValidation(
          this.getCountry().toUpperCase(),
          this.getApplicationId(),
          this.getStep2Object()
        )
        .subscribe();
      this.subscriptions.push(putUpdateRequestDataValidation$);
    } else {
      FormsValidators.markFormGroupTouched(this.formStepDataValidationLto);
    }
  }

  loadUpdateFormStep2() {
    this.buildForm(this.requestFormService.getUpdateForm());
    this.checkEvent();
  }

  buildForm(value: UpdateDataTokenCode) {
    this.getPostalCode(value.validation.postalCodeId?.number);

    this.formStepDataValidationLto.patchValue({
      uberProCategory:
        value?.validation?.scannedDataResponse.uberProCategory ||
        value?.validation?.uberResponse.uberProCategory,
      timeInApplication:
        value.validation.scannedDataResponse.antiquity ||
        value?.validation?.uberResponse.antiquity,
      totalTrips:
        value?.validation?.scannedDataResponse.totalTrips ||
        value?.validation?.uberResponse?.totalTrips,
      currentScore:
        value?.validation?.scannedDataResponse.rating ||
        value?.validation?.uberResponse?.rating,
      acceptanceIndex:
        value?.validation?.scannedDataResponse.acceptanceRate ||
        value?.validation?.uberResponse?.acceptanceRate,
      cancellationIndex:
        value?.validation?.scannedDataResponse.cancellationRate ||
        value?.validation?.uberResponse?.cancellationRate,
      dateOfBirth: value?.validation?.uberResponse?.dateOfBirth
        ? new Date(
          value?.validation?.uberResponse?.dateOfBirth.replace(
            /(\d+[/])(\d+[/])/,
            '$2$1'
          )
        )
        : '',
      drivingRole: value?.validation?.drivingRole,
      averageAmountUber:
        value.validation.averageAmountUber ||
        value?.validation?.uberResponse.average,
      postalCodeId: value.validation.postalCodeId?.number,
      street: value.validation.street,
      externalNumber: value.validation.externalNumber,
      internalNumber: value.validation.internalNumber,
      colonyId: value.validation.colony?.id,
      stateId: value.validation.state?.id,
      municipalityId: value.validation.municipality?.id,
      vehicleRelationCode: value.validation.vehicleRelationCode?.code,
      rentAmount: value.validation.rentAmount,
      vehicleCategoryId: value.validation.vehicleCategoryId?.id,
      totalDependents: value.validation.totalDependents,
    });
  }

  getPreviousPostalCode(event: any) {
    this.getPostalCode(event.target.value);
  }

  getPostalCode(event: string) {
    const getPostalCodeLtoMX$ = this.getDataService
      .getPostalCodeLtoMX(this.getCountry().toUpperCase(), event)
      .subscribe((resp) => {
        this.colonies = resp.colonies;
        this.formStepDataValidationLto
          .get('stateId')
          ?.setValue(resp.state.name);
        this.formStepDataValidationLto
          .get('municipalityId')
          ?.setValue(resp.municipality.name);
        this.codePostal = {
          state: resp.state,
          municipality: resp.municipality,
          id: resp.id,
        };
      });
    this.subscriptions.push(getPostalCodeLtoMX$);
  }

  getApplicationId() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('applicationId')!
      : this.requestFormService.getUpdateForm().id;
  }

  getCountry() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('language')!
      : this.requestFormService.getUpdateForm().countryCode.code.toLowerCase();
  }

  validInputRentPaymentAmount(event: MatOptionSelectionChange) {
    if (event.isUserInput) {
      if (event.source.value == 'REVE') {
        this.formStepDataValidationLto.controls['rentAmount'].setValidators([
          Validators.required,
        ]);
        this.formStepDataValidationLto.controls[
          'rentAmount'
        ].updateValueAndValidity();
      } else {
        this.formStepDataValidationLto.controls['rentAmount'].setValidators([]);
        this.formStepDataValidationLto.controls[
          'rentAmount'
        ].updateValueAndValidity();
      }
    }
  }
}
